/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Changelog_EyebrowInputs */

const en_marketing_changelog_eyebrow = /** @type {(inputs: Marketing_Changelog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_marketing_changelog_eyebrow = /** @type {(inputs: Marketing_Changelog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fr_marketing_changelog_eyebrow = /** @type {(inputs: Marketing_Changelog_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Marketing_Changelog_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_changelog_eyebrow = /** @type {((inputs?: Marketing_Changelog_EyebrowInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Changelog_EyebrowInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_changelog_eyebrow(inputs)
	if (locale === "es") return es_marketing_changelog_eyebrow(inputs)
	return fr_marketing_changelog_eyebrow(inputs)
});